import LoadingErrorPanel from '@/components/common/LoadingErrorPanel';
import { VStack } from '@/components/sgBootstrapReactWrapper';
import { usePersonsRolesQuery } from '@/store/api/person.api';
import { openedAccount } from '@/store/global/openedAccountPages';
import { useAppSelector } from '@/store/hooks';
import { personIdDisplayedInDrawer, setPersonIdDisplayedInDrawer } from '@/store/persons/slice';
import { getRootEntityOrSelected } from '@/store/user/userSlice';
import { isDefined } from '@/utils/assertions';
import { skipToken } from '@reduxjs/toolkit/query';
import { useNavigate } from '@tanstack/react-router';
import type { MouseEvent } from 'react';
import { useDispatch } from 'react-redux';
import LoadingMessage from '../LoadingMessage';
import RolesDrawerBody from './RolesDrawerBody';
import RolesDrawerHeader from './RolesDrawerHeader';

const RolesDrawer = () => {
  const dispatch = useDispatch();
  const personIdShownInDrawer = useAppSelector(personIdDisplayedInDrawer);
  const navigate = useNavigate();
  const rootId = useAppSelector(openedAccount)
  const entity = useAppSelector((state) => getRootEntityOrSelected(state, rootId))

  const {
    data: personsRolesData,
    isLoading,
    isFetching,
    isError,
    error,
  } = usePersonsRolesQuery(personIdShownInDrawer ? { personId: personIdShownInDrawer, entity } : skipToken);

  const handleClose = (e?: MouseEvent) => {
    e?.stopPropagation();
    dispatch(setPersonIdDisplayedInDrawer(null));
  };
  const onRootClick = (rootId: string, e?: MouseEvent) => {
    handleClose(e);
    navigate({ to: `/root/${rootId}` });
  };

  if (!personIdShownInDrawer) {
    return null;
  }

  return (
    <div>
      <div
        data-e2e="roles-details-drawer"
        className="offcanvas offcanvas-end show px-8px"
        style={{ width: 'auto' }}
      >
        <VStack>
          {isLoading || isFetching && <LoadingMessage />}
          {isError && <LoadingErrorPanel error={error} />}
          {isDefined(personsRolesData) && !(isLoading || isFetching) && (
            <>
              <RolesDrawerHeader onClose={handleClose} personsRolesData={personsRolesData} />
              <RolesDrawerBody onRootClick={onRootClick} personsRolesData={personsRolesData} />
            </>
          )}
        </VStack>
      </div>

      <div className="offcanvas-backdrop fade show" onClick={handleClose} />
    </div>
  );
};

export default RolesDrawer;
